import { useState } from "react";
import { motion } from "framer-motion";
import { Play, Maximize2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface VirtualTourProps {
  tourUrl: string;
  title: string;
  previewImage: string;
}

export const VirtualTour = ({ tourUrl, title, previewImage }: VirtualTourProps) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative aspect-video overflow-hidden bg-charcoal"
    >
      {!isActive ? (
        <>
          <img
            src={previewImage}
            alt={`${title} virtual tour preview`}
            className="w-full h-full object-cover opacity-80"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-charcoal/40">
            <button
              onClick={() => setIsActive(true)}
              className="w-20 h-20 rounded-full bg-gold flex items-center justify-center hover:scale-110 transition-transform duration-300 group"
              aria-label="Start virtual tour"
            >
              <Play className="text-cream ml-1" size={32} fill="currentColor" />
            </button>
            <p className="font-display text-2xl text-cream mt-6">Experience Virtual Tour</p>
            <p className="font-body text-cream/70 mt-2">360° Interactive Walkthrough</p>
          </div>
        </>
      ) : (
        <iframe
          src={tourUrl}
          title={`${title} Virtual Tour`}
          className="w-full h-full"
          allow="fullscreen; vr"
          allowFullScreen
        />
      )}
    </motion.div>
  );
};
